export const sendIntercomEvent = (name, metaData = {}) => {
  const Intercom = window.Intercom;
  if (Intercom) {
    Intercom('trackEvent', name, metaData);
  }
};
